// src/pages/AdminFinanzasPage.js
import React, { useState, useEffect } from 'react';
import { getResumenFinanzas, getDetalleDiario, getCostosPorMotor, getUmbrales, actualizarUmbral } from '../services/api';

const AdminFinanzasPage = () => {
  const [resumen, setResumen] = useState(null);
  const [detalle, setDetalle] = useState([]);
  const [motores, setMotores] = useState([]);
  const [umbrales, setUmbrales] = useState(null);
  const [alertas, setAlertas] = useState([]);
  const [periodo, setPeriodo] = useState('30d');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarDatos();
  }, [periodo]);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      const [res, det, mot, umb] = await Promise.all([
        getResumenFinanzas(),
        getDetalleDiario(30),
        getCostosPorMotor(periodo),
        getUmbrales()
      ]);
      setResumen(res.data);
      setDetalle(det.data.dias);
      setMotores(mot.data.motores);
      setUmbrales(umb.data.umbrales);
      setAlertas(umb.data.alertas);
    } catch (error) {
      console.error('Error cargando finanzas:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleActualizarUmbral = async (clave, valor) => {
    try {
      await actualizarUmbral(clave, valor);
      cargarDatos();
    } catch (error) {
      console.error('Error actualizando umbral:', error);
    }
  };

  if (loading) return <div className="loading">Cargando datos financieros...</div>;

  return (
    <div className="admin-finanzas">
      <h1>💰 Dashboard Financiero</h1>

      {/* Alertas */}
      {alertas.length > 0 && (
        <div className="alertas-container">
          <h3>⚠️ Alertas</h3>
          {alertas.map((alerta, i) => (
            <div key={i} className="alerta">{alerta}</div>
          ))}
        </div>
      )}

      {/* Resumen del día */}
      {resumen && (
        <div className="resumen-cards">
          <div className="resumen-card ingresos">
            <div className="resumen-icon">💰</div>
            <div className="resumen-contenido">
              <span className="resumen-label">Ingresos hoy</span>
              <span className="resumen-valor">${resumen.hoy.ingresos} MXN</span>
              <span className="resumen-tendencia">
                {resumen.hoy.ingresos > resumen.ayer.ingresos ? '▲' : '▼'} 
                {((resumen.hoy.ingresos - resumen.ayer.ingresos) / (resumen.ayer.ingresos || 1) * 100).toFixed(1)}%
              </span>
            </div>
          </div>

          <div className="resumen-card costos">
            <div className="resumen-icon">🤖</div>
            <div className="resumen-contenido">
              <span className="resumen-label">Costos IA hoy</span>
              <span className="resumen-valor">${resumen.hoy.costos} MXN</span>
            </div>
          </div>

          <div className="resumen-card ganancia">
            <div className="resumen-icon">📈</div>
            <div className="resumen-contenido">
              <span className="resumen-label">Ganancia neta</span>
              <span className="resumen-valor">${resumen.hoy.ganancia} MXN</span>
            </div>
          </div>

          <div className="resumen-card usuarios">
            <div className="resumen-icon">👥</div>
            <div className="resumen-contenido">
              <span className="resumen-label">Usuarios activos</span>
              <span className="resumen-valor">{resumen.hoy.usuarios}</span>
            </div>
          </div>
        </div>
      )}

      {/* Umbrales configurables */}
      {umbrales && (
        <div className="umbrales-section">
          <h3>⚙️ Umbrales de alerta</h3>
          <div className="umbrales-grid">
            <div className="umbral-item">
              <label>Diario ($MXN)</label>
              <input
                type="number"
                value={umbrales.umbral_diario}
                onChange={(e) => handleActualizarUmbral('umbral_diario', e.target.value)}
                className="umbral-input"
              />
            </div>
            <div className="umbral-item">
              <label>Semanal ($MXN)</label>
              <input
                type="number"
                value={umbrales.umbral_semanal}
                onChange={(e) => handleActualizarUmbral('umbral_semanal', e.target.value)}
                className="umbral-input"
              />
            </div>
            <div className="umbral-item">
              <label>Mensual ($MXN)</label>
              <input
                type="number"
                value={umbrales.umbral_mensual}
                onChange={(e) => handleActualizarUmbral('umbral_mensual', e.target.value)}
                className="umbral-input"
              />
            </div>
          </div>
        </div>
      )}

      {/* Costos por motor */}
      {motores.length > 0 && (
        <div className="motores-section">
          <h3>🤖 Costos por Motor IA</h3>
          <table className="tabla-motores">
            <thead>
              <tr>
                <th>Motor</th>
                <th>Solicitudes</th>
                <th>Total $MXN</th>
                <th>Promedio ms</th>
              </tr>
            </thead>
            <tbody>
              {motores.map(m => (
                <tr key={m.motor}>
                  <td>{m.motor}</td>
                  <td>{m.solicitudes}</td>
                  <td>${m.costo_total_mxn?.toFixed(2)}</td>
                  <td>{Math.round(m.tiempo_promedio_ms)}ms</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminFinanzasPage;